export default __webpack_public_path__ + "static/media/banner.92dab974.jpg";